import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.a`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 118px;
  height: 112px;
  cursor: pointer;

  ${media.medium`
    position: fixed;
    width: 184px;
    height: 178px;
  `}
`;
